import { Box } from "@mui/material";
import { FrameGlassType } from "utils/other/enums";

export default function FrameGlassCard({
  fullwidth=true,
  borderRadius = "40px",
  outline = "8px solid rgba(255, 255, 255, 0.30);",
  type = FrameGlassType.Translucent,
  ...props
}) {
  return (
    <Box
      sx={{
        display: !fullwidth ? "inline-block" : "block",
        overflow:"hidden",
        borderRadius: borderRadius,
        outline: outline,
        background:
          type === FrameGlassType.Translucent
            ? "radial-gradient(269.4% 140.45% at -0.45% 3.43%, rgba(231, 239, 255, 0.30) 0%, rgba(255, 255, 255, 0.00) 100%)"
            : "radial-gradient(267.72% 139.47% at 0% 2.78%, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.00) 100%)",
        backdropFilter: "blur(10px)",
      }}
    >
      {props.children}
    </Box>
  );
}
